import { Power1 } from 'gsap/all';
import TweenLite from 'TweenLite';
import TweenMax from 'TweenMax';
import TimelineMax from 'TimelineMax';
import ScrollMagic from 'ScrollMagic';
import 'animation.gsap';
import 'debug.addIndicators';
import Swiper from 'swiper';
import SplitText from "../gsap-bonus/SplitText";
import Player from '@vimeo/player';
import YouTubePlayer from 'youtube-player';
import { InitialiseCustomValidators } from './custom-validators'; //import $ from "jquery";

window.onload = function () {
  InitialiseCustomValidators(); // Add class to all external links

  document.querySelectorAll(".cta-link, .link-title a, .copy p a").forEach(el => {
    const url = el.href;

    const isExternalURL = url => new URL(url).origin !== location.origin;

    if (!isExternalURL) return;
    el.classList.add("external-link");
  }); // Explore More Swiper (Mobile only)

  document.querySelectorAll(".explore-more").forEach(el => {
    const panelsToAddEls = el.querySelectorAll(".explore-more__panel");
    const panelsMobileSliderContainer = el.querySelector(".explore-more__swiper .swiper-wrapper");
    panelsToAddEls.forEach(panelEl => {
      const cloned = panelEl.cloneNode(true);
      cloned.classList.remove("animateBlockStagger");
      cloned.classList.remove("col-xs-12");
      cloned.classList.remove("col-sm-4");
      cloned.style = "";
      const slideEl = document.createElement("div");
      slideEl.classList.add("swiper-slide");
      slideEl.appendChild(cloned);
      panelsMobileSliderContainer.appendChild(slideEl);
    });
    const swiperEl = el.querySelector('.explore-more__swiper');
    const mySwiperSliderExploreMore = new Swiper(swiperEl, {
      slidesPerView: 1.1,
      spaceBetween: 20,
      centeredSlides: false,
      draggable: true,
      loop: false,
      speed: 500,
      breakpoints: {
        768: {
          enabled: false
        }
      }
    });
  });
  document.querySelectorAll("select").forEach(el => {
    el.addEventListener("click", e => {
      e.target.parentElement.classList.toggle("active");
    });
    el.addEventListener("blur", e => {
      e.target.parentElement.classList.remove("active");
    });
  });
  let mySwiperSliderLogos = new Swiper(".logo-swiper", {
    direction: "horizontal",
    slidesPerView: "6",
    spaceBetween: 120,
    breakpoints: {
      576: {
        slidesPerView: "2",
        spaceBetween: 40
      },
      992: {
        slidesPerView: "4",
        spaceBetween: 80
      },
      1500: {
        slidesPerView: "6",
        spaceBetween: 80
      }
    },
    draggable: true,
    allowTouchMove: true,
    loop: false,
    autoHeight: true,
    speed: 500,
    autoplay: true
  });
  const controller = new ScrollMagic.Controller();

  if (document.querySelector("main p, main ol, main ul")) {
    let animateParap = document.querySelectorAll("main p:not(.noAnimate), main ol, main ul");
    animateParap.forEach(function (para) {
      if (para.closest(".noAnimate")) return;
      let animatePTween = new TimelineLite();
      TweenLite.set(para, {
        yPercent: 20,
        autoAlpha: 0
      });
      animatePTween = TweenMax.to(para, .5, {
        yPercent: 0,
        autoAlpha: 1,

        /*repeat:1, yoyo:true,*/
        ease: Power1.easeInOut
      }, 0);
      let animatePScene = new ScrollMagic.Scene({
        triggerElement: para,
        triggerHook: .85,
        reverse: true
      }).setTween(animatePTween).addTo(controller);
    });
  }

  if (document.querySelector("main h1, main h2, main h3, main h4, main h5")) {
    let count = 0;
    const animateTitle = document.querySelectorAll("main h1:not(.noAnimate), main h2:not(.noAnimate), main h3:not(.noAnimate), main h4:not(.noAnimate), main h5:not(.noAnimate)");
    animateTitle.forEach(function (title) {
      if (title.closest(".noAnimate")) return;
      TweenMax.set(title, {
        autoAlpha: 0,
        yPercent: 10
      });
      let animateTitleTween = new TimelineLite(),
          mySplitText = new SplitText(title, {
        type: "lines"
      }),
          chars = mySplitText.chars;
      TweenLite.set(title, {
        yPercent: 30
      });
      animateTitleTween = TweenMax.to(title, .5, {
        yPercent: 0,
        autoAlpha: 1,

        /*repeat:1, yoyo:true,*/
        ease: Power1.easeInOut
      }, 0);
      let animatePScene = new ScrollMagic.Scene({
        triggerElement: title,
        triggerHook: .85,
        reverse: true
      }).setTween(animateTitleTween).addTo(controller);
    });
  } //	animateSquare


  if (document.querySelector(".animateSquare")) {
    let count = 0; //TweenMax.set(".animateSquare", { autoAlpha: 0, yPercent: 10 });

    const boxElems = document.querySelectorAll(".animateSquare");
    boxElems.forEach(function (boxEl) {
      if (boxEl.closest(".noAnimate")) return;
      TweenMax.set(boxEl, {
        autoAlpha: 0,
        yPercent: 10
      });
      let animateSquareTween;
      count++;
      animateSquareTween = TweenMax.to(boxEl, .5, {
        yPercent: 0,
        autoAlpha: 1,

        /*repeat:1, yoyo:true,*/
        ease: Power1.easeInOut
      }, 0);
      let animateSquareScene = new ScrollMagic.Scene({
        triggerElement: boxEl,
        triggerHook: .85,
        reverse: true
      }).setTween(animateSquareTween).addTo(controller);
    });
  } //	animateBlockStagger


  const scrollAnchors = document.querySelector(".scroll-anchor");

  if (scrollAnchors) {
    scrollAnchors.addEventListener("click", function (e) {
      let anchor = e.target;
      let parts = anchor.href.split('#');
      let id = parts[parts.length - 1];

      if (id) {
        let element = document.getElementById(id);

        if (element) {
          e.preventDefault();
          const y = element.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({
            top: y,
            behavior: 'smooth'
          });
          setTimeout(() => {
            element.classList.add("throb-once");
            setTimeout(() => {
              element.classList.remove("throb-once");
            }, 1000);
          }, 800);
        }
      }
    });
  }

  if (document.querySelector(".animateBlockStaggerClients")) {
    TweenMax.set(".animateBlockStaggerClients", {
      autoAlpha: 0,
      yPercent: 10
    });
    let animateSquareStaggerTweenClients = TweenMax.staggerTo(".animateBlockStaggerClients", 0.5, {
      autoAlpha: 1,
      yPercent: 0,
      ease: Power1.easeInOut,
      stagger: '0.2'
    });
    let animateSquareStaggerSceneClients = new ScrollMagic.Scene({
      triggerElement: ".animateBlockStaggerContainerClients",
      triggerHook: .85,
      reverse: true
    }).setTween(animateSquareStaggerTweenClients).addTo(controller);
  } //	animateBlockStagger


  if (document.querySelector(".animateBlockStagger")) {
    TweenMax.set(".animateBlockStagger", {
      autoAlpha: 0,
      yPercent: 10
    });
    const animateSquareStaggerTween = TweenMax.staggerTo(".animateBlockStagger", 0.5, {
      autoAlpha: 1,
      yPercent: 0,
      ease: Power1.easeInOut,
      stagger: '0.2'
    });
    let animateSquareStaggerScene = new ScrollMagic.Scene({
      triggerElement: ".animateBlockStaggerContainer",
      triggerHook: .85,
      reverse: true
    }).setTween(animateSquareStaggerTween).addTo(controller);
  }

  if (document.querySelector(".animateBlockStaggerTwin")) {
    TweenMax.set(".animateBlockStaggerTwin", {
      autoAlpha: 0,
      yPercent: 10
    });
    const animateSquareStaggerTween = TweenMax.staggerTo(".animateBlockStaggerTwin", 0.5, {
      autoAlpha: 1,
      yPercent: 0,
      ease: Power1.easeInOut,
      stagger: '0.2'
    });
    let animateSquareStaggerScene = new ScrollMagic.Scene({
      triggerElement: ".animateBlockStaggerTwinContainer",
      triggerHook: .85,
      reverse: true
    }).setTween(animateSquareStaggerTween).addTo(controller);
  } //	Navigation


  const hamburger = document.querySelector(".hamburger");
  const hamburgerContainer = document.querySelector(".hamburger--container");
  const navigation = document.getElementById("navScene");
  const headerBg = document.querySelector(".headerBackground .background");
  const hdrLogo = document.querySelector(".hdr-logo-link");
  let navTl = new TimelineMax({
    paused: true,
    onReverseComplete: reverseFunction
  });
  navTl.to(hdrLogo, 0.1, {
    opacity: 1,
    ease: Power1.easeInOut
  }).to(headerBg, 0.4, {
    height: '100vh',
    ease: Power1.easeInOut
  }).to(navigation, 0.4, {
    top: '0',
    ease: Power1.easeInOut,
    opacity: 1
  }, "-=0.4").addLabel("reverseFrom").staggerFromTo(".menu-links a", 0.4, {
    opacity: 0,
    y: -30
  }, {
    opacity: 1,
    y: '+=30',
    stagger: '+0.05'
  }, "-=0.2").staggerFromTo(".stagger-animation", 1, {
    opacity: 0,
    y: -15
  }, {
    opacity: 1,
    y: '0'
  }, "-=2");

  function reverseFunction() {
    document.body.className = document.body.className.replace("nav-open", "");
  }

  hamburger.addEventListener("click", function () {
    if (hamburger.classList.contains("is-active")) {
      navTl.reverse("reverseFrom");
    } else {
      document.body.classList.add("nav-open");
      navTl.play();
    }

    hamburger.classList.toggle("is-active"); // header.classList.toggle("is-active");

    if (hamburgerContainer) {
      hamburgerContainer.classList.toggle("is-active");
    }
  }); //	If Group Homepage Nav

  if ($('#group-home').length > 0) {
    const offset = 20; //Offset of 20px

    const purposeBtn = document.querySelector(".purposeBtn a");
    purposeBtn.addEventListener("click", function () {
      hamburger.classList.toggle("is-active");
      navTl.reverse("reverseFrom");
      $('html, body').animate({
        scrollTop: $("#purpose").offset().top + offset
      }, 2000);
      return false;
    });
    const principlesBtn = document.querySelector(".principlesBtn a");
    principlesBtn.addEventListener("click", function () {
      hamburger.classList.toggle("is-active");
      navTl.reverse("reverseFrom");
      $('html, body').animate({
        scrollTop: $("#principles").offset().top + offset
      }, 2000);
      return false;
    });
    const processBtn = document.querySelector(".processBtn a");
    processBtn.addEventListener("click", function () {
      hamburger.classList.toggle("is-active");
      navTl.reverse("reverseFrom");
      $('html, body').animate({
        scrollTop: $("#process").offset().top + offset
      }, 2000);
      return false;
    });
    const placesBtn = document.querySelector(".placesBtn a");
    placesBtn.addEventListener("click", function () {
      hamburger.classList.toggle("is-active");
      navTl.reverse("reverseFrom");
      $('html, body').animate({
        scrollTop: $("#places").offset().top + offset
      }, 2000);
      return false;
    });
  }

  const customSliderSettings = {
    slidesPerView: 'auto',
    centeredSlides: true,
    draggable: true,
    centeredSlides: true,
    speed: 500,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      disabledClass: 'disable'
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
      renderFraction: function (currentClass, totalClass) {
        return '<div class="row middle-xs between-xs"><div class="' + currentClass + ' col-xs-3 col-sm-2"></div>' + '<div class="carousel-line col-xs-4 col-sm-6"></div>' + '<div class="' + totalClass + ' col-xs-3 col-sm-2"></div></div>';
      },
      formatFractionCurrent: function (number) {
        return number > 9 ? "" + number : "0" + number;
      },
      formatFractionTotal: function (number) {
        return number > 9 ? "" + number : "0" + number;
      }
    }
  }; //	Quote Swiper

  const mySwiperSliderQuote = new Swiper('.quote-swiper', customSliderSettings);
  const mySwiperSliderHome = new Swiper('.home-cs-swiper', customSliderSettings);
  let mySwiperSliderValues = new Swiper('.values-swiper', {
    slidesPerView: 'auto',
    centeredSlides: true,
    draggable: false,
    allowTouchMove: false,
    loop: false,
    centeredSlides: true,
    speed: 500
  });
  const swiperlink = document.querySelectorAll('.swiper-link');
  Array.prototype.forEach.call(swiperlink, function (elements, index) {
    elements.addEventListener("click", function () {
      Array.prototype.forEach.call(swiperlink, function (elements, index) {
        elements.classList.remove("active");
      });
      elements.classList.add("active");
      mySwiperSliderValues.slideTo(elements.getAttribute('data-slide'));
      event.preventDefault();
    });
  });
  const mySwiperSliderContent = new Swiper('.content-swiper', customSliderSettings);
};

$(document).ready(function () {
  let windowWidth = $(window).width(),
      checkScreensize = debounce(function () {
    windowWidth = $(window).width();
  }, 250);
  $(window).resize(checkScreensize);
  $(".animated-svg").each(function (index) {
    let name = $(this).attr('id');
    let targetSVG = $(this).data('animated');
    let animated = bodymovin.loadAnimation({
      container: document.getElementById(name),
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: '/theme/images/animated/' + targetSVG + '.json'
    });
    $('#' + name).mouseover(function () {
      animated.setDirection(1);
      animated.play();
    });
    $('#' + name).mouseout(function () {
      animated.setDirection(-1);
      animated.play();
    });
  });
  $(".animated-svg-play").each(function (index) {
    let name = $(this).attr('id');
    let targetSVG = $(this).data('animated');
    let animated = bodymovin.loadAnimation({
      container: document.getElementById(name),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/theme/images/animated/' + targetSVG + '.json'
    });
    $('#' + name).mouseover(function () {
      animated.setDirection(-1);
      animated.play();
    });
    $('#' + name).mouseout(function () {
      animated.setDirection(1);
      animated.play();
    });
  });
  $(".animated-svg-play-once").each(function (index) {
    let name = $(this).attr('id');
    let targetSVG = $(this).data('animated');
    let animated = bodymovin.loadAnimation({
      container: document.getElementById(name),
      renderer: 'svg',
      loop: false,
      autoplay: true,
      path: '/theme/images/animated/' + targetSVG + '.json'
    });
    $(".playbutton-home").on('click', function () {
      animated.setDirection(-1);
      animated.play();
    });
  });
  $(".animated-svg-play-to-frame").each(function (index) {
    let name = $(this).attr('id');
    let targetSVG = $(this).data('animated');
    let animated = bodymovin.loadAnimation({
      container: document.getElementById(name),
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: '/theme/images/animated/' + targetSVG + '.json'
    });
    $('#' + name).mouseover(function () {
      animated.setDirection(1);
      animated.playSegments([0, 11], true);
    });
    $('#' + name).mouseout(function () {
      animated.setDirection(-1);
      animated.play();
    });
  });
  $(".capabilities-services__content-svg").each(function (index) {
    let name = $(this).attr('id');
    let parent = $(this).parent().parent().parent().parent();
    let targetSVG = $(this).data('animated');
    let animated = bodymovin.loadAnimation({
      container: document.getElementById(name),
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: '/theme/images/animated/' + targetSVG + '.json'
    });
    $(parent).mouseover(function () {
      animated.setDirection(1);
      animated.play();
    });
    $(parent).mouseout(function () {
      animated.setDirection(-1);
      animated.play();
    });
  });
  $(".animated-svg-parent").each(function (index) {
    let name = $(this).find('.animated-svg-child').attr('id');
    let targetSVG = $(this).find('.animated-svg-child').data('animated');
    let animated = bodymovin.loadAnimation({
      container: document.getElementById(name),
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: '/theme/images/animated/' + targetSVG + '.json'
    });
    $(this).mouseover(function () {
      animated.setDirection(1);
      animated.play();
    });
    $(this).mouseout(function () {
      animated.setDirection(-1);
      animated.play();
    });
  }); // Hide mission logo near the bottom of the page

  $(window).scroll(function () {
    if ($(window).scrollTop() + $(window).height() > $(document).height() - ($('#footer').height() + 50)) {
      $('.mission_logo_sticky').addClass('fade-out');
    } else {
      $('.mission_logo_sticky').removeClass('fade-out');
    }
  });

  if ($('#header_video').length) {
    const $headerVideo = $('#header_video');
    const $desktopImage = $('.page-header__image__desktop');
    const $mobileImage = $('.page-header__image__mobile');
    const $muteToggle = $('.page-header__mute-toggle');

    const getVideoConfig = () => {
      const width = $(window).width();
      const videoId = width > 767 ? $headerVideo.data('vimeo-vid') : $headerVideo.data('vimeo-vid-mobile');
      const staticImage = width > 767 ? $desktopImage : $mobileImage;
      return {
        videoId,
        staticImage
      };
    };

    const {
      videoId,
      staticImage
    } = getVideoConfig();
    const loop = $headerVideo.data('video-loop') === 'yes';
    const player = new Player('header_video', {
      url: `//player.vimeo.com/video/${videoId}`,
      background: true,
      muted: true,
      loop
    });
    player.on('play', () => {
      $muteToggle.addClass("enabled");
      ;
      const {
        staticImage
      } = getVideoConfig();
      staticImage.fadeOut();
    });
    player.on('ended', () => () => {
      const {
        staticImage
      } = getVideoConfig();
      staticImage.fadeIn();
    });
    $muteToggle.on('click', async () => {
      const isMuted = await player.getMuted();

      if (isMuted) {
        player.setMuted(false);
        $muteToggle.addClass('unmuted');
      } else {
        player.setMuted(true);
        $muteToggle.removeClass('unmuted');
      }
    });
    $(window).on('resize', () => {
      const {
        videoId: newId
      } = getVideoConfig();
      $muteToggle.removeClass("unmuted");
      player.setMuted(true);
      player.getVideoId().then(currentId => {
        if (currentId !== newId) {
          player.loadVideo(newId);
        }
      });
    });
  } ////////****** VIDEO FUNCTIONALITY *********


  let videoiframe,
      player,
      videoID,
      vimeothumbnail = [],
      wrapperIndex,
      playerArray = [];
  let players = new Array();
  let videoIDs = new Array();
  let allthumbnails = $('body').find('.full-width-video__thumbnail');
  let $vimeoVideos = $('.vimeoVideo');

  if ($vimeoVideos.length > 0) {
    $vimeoVideos.each(function () {
      videoiframe = $(this).find('.video-player');
      if (videoiframe.length === 0) return;
      videoID = videoiframe.attr('id');
      if (!videoID) return;
      player = new Player(videoID);
      playerArray.push(player);
    });
    $vimeoVideos.on('click', function () {
      stopAllVideos();
      wrapperIndex = $('.vimeoVideo').index(this);
      vimeothumbnail = $(this).find('.full-width-video__thumbnail');
      playerArray[wrapperIndex].setCurrentTime(0);
      playerArray[wrapperIndex].play();
      const $vimeoVideo = $(this);
      $vimeoVideo.addClass("buffering");
      playerArray[wrapperIndex].on('bufferend', function () {
        $vimeoVideo.removeClass("buffering");
      });
      playerArray[wrapperIndex].on('seeked', function () {
        vimeothumbnail.fadeIn(200);
        $vimeoVideo.addClass("buffering");
      });
      playerArray[wrapperIndex].on('play', function () {
        setTimeout(function () {
          vimeothumbnail.fadeOut(200);
        }, 200);
      });
      playerArray[wrapperIndex].on('pause', function () {
        $vimeoVideo.removeClass("buffering");
        vimeothumbnail.fadeIn(200);
      });
    });
  }

  function stopAllVideos() {
    //	Stop YouTube videos
    for (let i = 0; i < players.length; i++) {
      players[i].stopVideo();
    } //	Stop Vimeo videos


    for (let i = 0; i < playerArray.length; i++) {
      playerArray[i].pause().then(function () {
        allthumbnails.fadeIn(200);
      });
    }
  }

  let $youtubeVideos = $('.youTubeVideo');

  if ($youtubeVideos.length > 0) {
    //Set up the videos
    $youtubeVideos.each(function () {
      let player1, thumbnail, videoiframe, videoID, player;
      thumbnail = $(this).find('.full-width-video__thumbnail');
      videoiframe = $(this).find('.video-player');
      videoID = videoiframe.attr('data-video-id');
      player = 'player-' + videoID;
      player1 = YouTubePlayer(player, {
        videoId: videoID,
        playerVars: {
          'controls': 0,
          'rel': 0,
          'modestbranding': 1
        }
      });
      player1.on('stateChange', function (event) {
        if (event.data == 2) {
          setTimeout(function () {
            thumbnail.fadeIn(200);
          }, 200);
        }
      });
      players.push(player1);
      videoIDs.push(videoID);
    });
  } //	Play the videos


  for (let i = 0; i < players.length; i++) {
    let playerContainer, thumbnail;
    playerContainer = $('body').find('.youTubeVideo' + videoIDs[i]);
    playerContainer.attr("data-videoCount", i);
    $(playerContainer).on('click', function () {
      stopAllVideos();
      thumbnail = $(this).find('.full-width-video__thumbnail');
      players[$(this).attr("data-videoCount")].playVideo().then(function () {
        setTimeout(function () {
          thumbnail.fadeOut(200);
        }, 200);
      });
    });
  } ////////****** END: VIDEO FUNCTIONALITY *********


  $(".capabilities-leadership").each(function (index) {
    let leadershipContent = $(this).find('.capabilities-leadership__content'),
        leadershipContentCurrent = $(this).find('.capabilities-leadership__content.current'),
        leadershipPanel = $(this).find('.capabilities-leadership__panel'),
        leadershipContentDefault = $(this).find('.capabilities-leadership__content.default'),
        leadershipProfiles = $(this).find('.capabilities-leadership__profiles'),
        panelAmount = $(this).find('.capabilities-leadership__panel').length,
        readMorePanel = $(this).find('.capabilities-leadership__read-more'),
        windowWidth = $(window).width(),
        leadershipPanelIndex,
        readMoreTrigger;
    leadershipContent.hide();
    readMorePanel.hide();
    leadershipContentCurrent.show();
    leadershipPanel.on('click', function () {
      if (windowWidth > 767) {
        if ($(this).hasClass('activeImage')) {
          $(this).removeClass('activeImage');
          leadershipContent.removeClass('current').hide();
          leadershipContentDefault.addClass('current').show();
          $(leadershipProfiles).removeClass('panelActive');
        } else {
          $(leadershipProfiles).find('.activeImage').removeClass('activeImage');
          $(this).addClass('activeImage');
          $(leadershipProfiles).addClass('panelActive');
          leadershipPanelIndex = $($(this).data('profile-panel'));
          leadershipContent.removeClass('current').hide();
          leadershipPanelIndex.addClass('current').show();
        }
      }
    });
    $(this).find('.content-close').on('click', function () {
      if (windowWidth > 767) {
        $(this).parents('.capabilities-leadership__content').removeClass('current').hide();
        $(this).parent().parent().find('.capabilities-leadership__content.default').addClass('current').show();
        $(leadershipProfiles).find('.activeImage').removeClass('activeImage');
        $(leadershipProfiles).removeClass('panelActive');
      } else {
        if (readMorePanel) {
          $(this).parents('.capabilities-leadership__read-more').slideToggle();
          readMoreTrigger.fadeIn();
        }
      }
    });
    $(this).find('.read-more-info').on('click', function () {
      readMoreTrigger = $(this);
      readMoreTrigger.fadeOut();
      readMorePanel = $(this).data('read-more');
      $(readMorePanel).slideToggle();
    });
  });
});

if (!$('#group-home').length > 0) {
  let $navi = $(".header, .headerBackground"),
      scrollTop = 0;
  let previousScrollTop = 0;
  const $window = $(window);
  const $pageHeader = $(".page-header");
  const $header = $("header");
  const $headerBackground = $(".headerBackground");
  const $body = $("body");
  $window.on("scroll resize", function () {
    const y = $(this).scrollTop();
    let speed = 0.25,
        pos = y * speed,
        maxPos = 100;
    scrollTop = y;
    const scrolLDirection = scrollTop - previousScrollTop;
    const headerScrolledOffTop = y > $pageHeader.innerHeight();
    const isScrollingUp = scrolLDirection <= 0 && y > 0;
    pos = 0;
    $body.toggleClass("scrolled-below-header", headerScrolledOffTop && !isScrollingUp);
    $headerBackground.toggleClass("white", isScrollingUp);
    $header.toggleClass('scrolled-up', isScrollingUp);
    $body.toggleClass('scrolled-up', isScrollingUp);
    $navi.css({
      "-webkit-transform": "translate3d(0,-" + pos + "%,0)",
      "-moz-transform": "translate3d(0,-" + pos + "%,0)",
      "-o-transform": "translate3d(0,-" + pos + "%,0)",
      "transform": "translate3d(0,-" + pos + "%,0)"
    });
    previousScrollTop = y;
  });
}

$.fn.isInViewport = function () {
  let elementTop = $(this).offset().top;
  let elementBottom = elementTop + $(this).outerHeight();
  let navTop = $('.headerBackground').offset().top;
  let navBottom = navTop + $('.headerBackground').outerHeight();
  return navTop > elementTop && navBottom < elementBottom;
};

(function () {
  let activeService,
      currentDetail,
      mobileDetail,
      services = [],
      count = 0,
      x = 0,
      overlayHeights = [],
      overlayHeightsSorted = [],
      maxHeight;
  sortHeights();
  let resizeTimer;
  $(window).on('resize', function (e) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      overlayHeights = [];
      overlayHeightsSorted = [];
      sortHeights();
    }, 250);
  });

  function sortHeights() {
    if ($(window).width() > 768) {
      let maxHeight = 0;
      $('.service-overlay .detail-content').each(function () {
        const height = $(this).height();

        if (height > maxHeight) {
          maxHeight = height;
        }
      });
      $('.service-detail-wrapper.default-content').css({
        'min-height': maxHeight
      });
    }
  }

  $('.capabilities-services__content').each(function (x) {
    x++;
    const $this = $(this);

    if ($(this).hasClass("overlay-disabled")) {
      return;
    }

    services[x] = new TimelineMax({
      paused: true
    });
    mobileDetail = $this.parent().next('.capabilities-services__mobile-detail');
    services[x].fromTo($('.display-' + x), 0.4, {
      opacity: '0',
      right: '-100%'
    }, {
      opacity: '1',
      right: '0',
      ease: Power3.out
    }).fromTo($('.default-content'), 0.4, {
      opacity: '1',
      top: '20px'
    }, {
      opacity: '0',
      top: '100px',
      ease: Power3.out
    }, '-=0.4');
    $('.service-' + x).on('click', function () {
      mobileDetail = $(this).parent().next('.capabilities-services__mobile-detail');

      if ($(window).width() > 768) {
        services[x].play();
      } else {
        mobileDetail.slideToggle();

        if ($(this).hasClass('active-content')) {
          $(this).removeClass('active-content');
        } else {
          $(this).addClass('active-content');
        }
      }
    });
    $('.detail-close').on('click', function () {
      if ($(window).width() > 768) {
        //$('.detail-close').css('opacity', 0);
        services[x].reverse();
      }
    });
  });
})();

function debounce(func, wait, immediate) {
  let timeout;
  return function () {
    let context = this,
        args = arguments;

    let later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

;